import { useCallback, useEffect, useState } from "react";
import { Download, FileText, Pencil, Plus, Star, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, API } from "@/lib/api";
import { invalidateModels } from "@/hooks/useModels";
import { ModelForm } from "./ModelForm";

export const ModelsPanel = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = useCallback(() => {
    api.get("/models").then((r) => setItems(Array.isArray(r.data) ? r.data : []));
    invalidateModels();
  }, []);
  useEffect(() => { load(); }, [load]);

  const remove = async (m) => {
    if (!window.confirm(`Eliminare ${m.name}?`)) return;
    await api.delete(`/admin/models/${m.id}`);
    toast.success("Modella eliminata");
    load();
  };

  return (
    <div data-testid="models-panel">
      <div className="flex flex-wrap gap-3">
        <button onClick={() => setEditing({})} data-testid="add-model-button" className="flex items-center gap-2 bg-[#1c1418] px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-[#f4ede6]">
          <Plus className="h-4 w-4 text-[#e9458f]" /> Nuova modella
        </button>
        <a href={`${API}/admin/composites.zip`} onClick={() => toast("Preparo i PDF di tutte le modelle… il download parte tra qualche secondo")}
          data-testid="download-all-composites" className="flex items-center gap-2 border border-[#1c1418] px-5 py-3 font-mono text-xs uppercase tracking-[0.2em]">
          <Download className="h-4 w-4 text-[#e9458f]" /> Scarica tutti i PDF (ZIP)
        </a>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {items.map((m) => (
          <div key={m.id} data-testid={`admin-model-${m.slug}`} className="group">
            <div className="relative aspect-[2/3] overflow-hidden bg-[#1c1418]">
              {m.images?.[0] && <img src={m.images[0]} alt="" loading="lazy" className="h-full w-full object-cover" />}
              {m.featured && <Star className="absolute left-2 top-2 h-5 w-5 fill-[#e9458f] text-[#e9458f]" />}
              <div className="absolute inset-x-0 bottom-0 flex justify-end gap-1 p-2">
                <a href={`${API}/models/${m.slug}/composite.pdf`} data-testid={`pdf-model-${m.slug}`} title="Scarica PDF" className="grid h-9 w-9 place-items-center bg-white"><FileText className="h-4 w-4 text-[#e9458f]" /></a>
                <button onClick={() => setEditing(m)} data-testid={`edit-model-${m.slug}`} className="grid h-9 w-9 place-items-center bg-white"><Pencil className="h-4 w-4" /></button>
                <button onClick={() => remove(m)} data-testid={`delete-model-${m.slug}`} className="grid h-9 w-9 place-items-center bg-[#1c1418] text-white"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            <p className="mt-2 font-display text-xl uppercase leading-none">{m.name}</p>
            <p className="font-mono text-[11px] text-[#1c1418]/60">{m.images?.length || 0} foto</p>
          </div>
        ))}
      </div>
      {editing && <ModelForm model={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
};
